export default __webpack_public_path__ + "img/410c44650b465cde739cf12034e5c9f3.svg";